import { Component } from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';
// import { InputErrorType } from 'types/CommonTypes';
import withRequired from './withRequired';

class InputEmail extends Component {
  render() {
    let errorMgs;

    if (this.props.errors) {
      this.props.errors.details.forEach((error) => {
        if (error.fieldName === this.props.name) {
          errorMgs = error.messages;
        }
      });
    }

    return (
      <FormGroup>
        {this.props.label ? (
          <Label for={this.props.name} className="small">
            {this.props.required && this.props.showAsterisk ? <sup>*</sup> : ''}
            {this.props.label}
          </Label>
        ) : (
          ''
        )}

        <Input
          type="email"
          name={this.props.name}
          autoComplete={this.props.autoComplete}
          value={this.props.value || ''}
          onChange={this.props.handleChange}
          required={this.props.required}
          placeholder={this.props.placeholder}
          invalid={errorMgs ? true : false}
        />

        <FormFeedback className="ps-0 mt-1">
          {errorMgs
            ? errorMgs.map((message, k) => (
                <li key={k} className="description" style={{ listStyle: 'none' }}>
                  {message}
                </li>
              ))
            : ''}
        </FormFeedback>
      </FormGroup>
    );
  }
}

InputEmail.propTypes = {
  // errors: InputErrorType,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
  required: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  showAsterisk: PropTypes.bool,
};

InputEmail.defaultProps = {
  errors: undefined,
  label: null,
  autoComplete: null,
  required: false,
  placeholder: null,
  value: undefined,
  showAsterisk: true,
};

export default withRequired(InputEmail);
